export default {"src":"/_next/static/media/header.b2eb858b.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};